<template>
  <div>
    <NuxtPage />
    <div id="teleport-target"></div>
    <l-call-back />
  </div>
</template>
